/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BuilderUserContext } from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import {
  DictionaryItem,
  FormState,
  FormStateBuilder,
  getDialogInitData,
  whenEditMode,
} from '@gh/common-shared';
import { DialogInput, FormMode } from '@gh/core-ui';

import { LeadBoardBusinessService } from '../../../../../resources/lead-board-business.service';
import { LeadBoardCardMoveDialogConfig, LeadBoardColumnId } from '../../../../../resources/lead-board.model';

@Component({
  selector: 'gh-lead-board-card-move-dialog',
  template: require('./lead-board-card-move-dialog.component.html'),
  styles: [require('./lead-board-card-move-dialog.component.scss')],
})
export class LeadBoardCardMoveDialogComponent implements OnInit, DialogInput<LeadBoardCardMoveDialogConfig> {
  input: LeadBoardCardMoveDialogConfig;
  form: FormState<LeadBoardColumnId>;

  priorities: DictionaryItem<any>[];
  stages: DictionaryItem<any>[];

  constructor(private dialogRef: MatDialogRef<any>,
              @Inject(MAT_DIALOG_DATA) private dialogData: any,
              private businessService: LeadBoardBusinessService,
              private userContext: BuilderUserContext,
              private formStateBuilder: FormStateBuilder) {
  }

  ngOnInit(): void {
    const { stages, priorities } = getDialogInitData(this.dialogData);
    this.stages = stages;
    this.priorities = priorities;

    this.form = this.formStateBuilder.buildPlain({
      mode: this.userContext.hasPermission(BuilderPermission.Sales.Leads.EDIT) ? FormMode.EditMode : FormMode.ViewMode,
      enabled: whenEditMode(),
      value: {
        stage: this.input.card.stage,
        priority: this.input.card.priority,
      },
      children: {
        stage: { required: true },
        priority: { required: true },
      },
    });
  }

  onMove(): void {
    if (this.form.group.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close({
      ...this.form.submitValue,
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
